import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'current', 'count']
  static values = {
    max: { type: Number, default: 280 }
  }

  connect() {
    this.count()
  }

  count() {
    const length = this.inputTarget.value.length
    this.currentTarget.textContent = length

    if (length > this.maxValue) {
      this.currentTarget.classList.add('text-red-600', 'font-medium')
      this.currentTarget.classList.remove('text-text-muted')
    } else if (length > this.maxValue * 0.9) {
      this.currentTarget.classList.add('text-yellow-600')
      this.currentTarget.classList.remove('text-text-muted', 'text-red-600', 'font-medium')
    } else {
      this.currentTarget.classList.add('text-text-muted')
      this.currentTarget.classList.remove('text-red-600', 'text-yellow-600', 'font-medium')
    }
  }
}
